import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { AppLayout } from '@/components/layout/AppLayout';

/**
 * 認証が必要なルート群の pathless レイアウト。
 *
 * `beforeLoad` で未ログインを検知して /login にリダイレクトする。
 * 未確定 state で誤判定しないよう、main.tsx 側で auth.isLoading 解決後に
 * RouterProvider を描画する点に依存する。
 */
export const Route = createFileRoute('/_authenticated')({
  beforeLoad: ({ context, location }) => {
    if (!context.auth.isAuthenticated) {
      throw redirect({
        to: '/login',
        search: { redirect: location.href },
      });
    }
  },
  component: AuthenticatedLayout,
});

function AuthenticatedLayout() {
  return (
    <AppLayout>
      <Outlet />
    </AppLayout>
  );
}
